import React, { useState } from 'react';
import axios from 'axios';
import { Camera, CheckCircle2, IdCard, Upload } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { formatApiError } from "../../lib/apiError";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Slot = ({ id, label, file, onChange }) => {
  const preview = file ? URL.createObjectURL(file) : null;
  return (
    <label htmlFor={id} data-testid={`${id}-slot`} className={`relative flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed p-4 min-h-[150px] cursor-pointer transition-colors overflow-hidden ${file ? "border-brand-green bg-brand-lightGreen/40" : "border-gray-200 hover:border-brand-blue bg-gray-50"}`}>
      {preview ? <img src={preview} alt={label} className="absolute inset-0 w-full h-full object-cover opacity-90" /> : <Camera className="w-7 h-7 text-gray-400" />}
      <span className={`relative z-10 text-xs font-bold px-2 py-1 rounded-full ${file ? "bg-brand-green text-brand-dark" : "text-gray-600"}`}>{file ? <><CheckCircle2 className="w-3 h-3 inline mr-1" />{label} listo</> : label}</span>
      <input id={id} data-testid={`${id}-input`} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => onChange(e.target.files?.[0] || null)} />
    </label>
  );
};

export const IneUpload = ({ onUploaded }) => {
  const [front, setFront] = useState(null);
  const [back, setBack] = useState(null);
  const [uploading, setUploading] = useState(false);

  const upload = async () => {
    if (!front || !back) { toast.error("Sube el frente y el reverso de tu INE"); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("front", front);
      fd.append("back", back);
      const res = await axios.post(`${BACKEND_URL}/api/auth/me/ine`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(res.data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail, "No se pudieron subir los documentos"));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="ine-upload">
      <div className="rounded-xl bg-brand-lightBlue/60 p-3 text-xs text-brand-dark flex gap-2">
        <IdCard className="w-4 h-4 text-brand-blue shrink-0 mt-0.5" />
        <p>Tus documentos se guardan cifrados y solo tú puedes verlos. Quedarán en <strong>revisión pendiente</strong> hasta que se integre la verificación automática.</p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Slot id="ine-front" label="Frente del INE" file={front} onChange={setFront} />
        <Slot id="ine-back" label="Reverso del INE" file={back} onChange={setBack} />
      </div>
      <Button type="button" onClick={upload} disabled={uploading || !front || !back} data-testid="ine-submit-btn" className="w-full h-12 bg-brand-blue text-white font-bold rounded-xl">
        <Upload className="w-4 h-4 mr-2" /> {uploading ? "Subiendo..." : "Enviar documentos"}
      </Button>
    </div>
  );
};
